import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { Mail } from 'lucide-react';

export default function EsqueciSenhaPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return setErro('Informe seu email');
    setLoading(true);
    setErro('');
    try {
      await api.post('/auth/esqueci-senha', { email });
      setEnviado(true);
    } catch {
      setErro('Erro ao enviar. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 max-w-md w-full">
        {enviado ? (
          <div className="text-center">
            <div className="text-5xl mb-4">📧</div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Verifique seu email</h2>
            <p className="text-gray-500 mb-6">Se o email existir em nossa base, você receberá as instruções para redefinir sua senha em alguns minutos.</p>
            <Link to="/login" className="text-blue-600 hover:underline text-sm font-medium">Voltar ao login</Link>
          </div>
        ) : (
          <>
            <h1 className="text-xl font-bold text-gray-900 mb-1">Esqueci minha senha</h1>
            <p className="text-sm text-gray-400 mb-6">Informe seu email e enviaremos as instruções.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="seuemail@exemplo.com"
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  />
                </div>
              </div>
              {erro && <p className="text-sm text-red-500">{erro}</p>}
              <button type="submit" disabled={loading}
                className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white rounded-xl text-sm font-medium transition-colors">
                {loading ? 'Enviando...' : 'Enviar instruções'}
              </button>
            </form>
            <p className="text-center mt-4 text-sm text-gray-500">
              <Link to="/login" className="text-blue-600 hover:underline">Voltar ao login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}